// Tabs of an event's page with the settings of this event (um/2026-10-30/03 п.4, ITConf's conference workspace: «Цены», «Скидки»,
// «Партнёры», «Экраны»): the event's own offers, waves, codes, partners, venue and materials, opened from its card in «Настройка события» of «Билеты».
import { LinkedTable, type RecordTab } from '@confdeck/core-web';

const Prices = ({ recordId }: { recordId: string }) => (
  <>
    <LinkedTable recordId={recordId} field="offers" title="Варианты участия" columns={['name', 'kind', 'state', 'price', 'quota', 'sold', 'left', 'sales_to']} empty="Вариантов участия нет — без них продажа не откроется" />
    <LinkedTable recordId={recordId} field="price_periods" optional title="Волны цен" columns={['name', 'starts', 'ends']} empty="Волн нет: действует цена варианта" />
  </>
);
const Discounts = ({ recordId }: { recordId: string }) => (
  <LinkedTable recordId={recordId} field="promos" optional title="Промокоды" columns={['code', 'kind', 'value_percent', 'value_money', 'limit', 'used', 'status', 'valid_to']} empty="Промокодов нет. Скидки за количество — в карточке варианта участия." />
);
const Partners = ({ recordId }: { recordId: string }) => (
  <LinkedTable recordId={recordId} field="partnerships" optional title="Партнёры события" columns={['title', 'company', 'level', 'package', 'payment', 'published']} empty="Партнёров нет" />
);
const Venue = ({ recordId }: { recordId: string }) => (
  <>
    <LinkedTable recordId={recordId} field="screens" optional title="Инфоэкраны" columns={['title', 'room', 'date', 'mode', 'active']} empty="Экранов нет" />
    <LinkedTable recordId={recordId} field="streams" optional title="Трансляции" columns={['title', 'room', 'url', 'active']} empty="Трансляций нет" />
  </>
);
// R-E11 (decision 043): the sets of materials with their rule, and the materials a manual set chooses from.
const Materials = ({ recordId }: { recordId: string }) => (
  <>
    <LinkedTable recordId={recordId} field="material_sets" title="Наборы материалов" columns={['name', 'source', 'access', 'offers', 'opens_on', 'closes_on']} empty="Наборов нет: материалы не открыты никому" />
    <LinkedTable recordId={recordId} field="materials" optional title="Материалы" columns={['title', 'talk', 'url', 'sets']} empty="Материалов нет" />
  </>
);

/** `field`: without it (a feature switched off, decision 025) the tab is not shown. */
export const eventSettingsTabs: RecordTab[] = [
  { key: 'prices', label: 'Цены', component: Prices, field: 'offers' },
  { key: 'discounts', label: 'Скидки', component: Discounts, field: 'promos' },
  { key: 'partners', label: 'Партнёры', component: Partners, field: 'partnerships' },
  // A broadcast has streams without hall screens (R-E9): the tab is there while either is.
  { key: 'venue', label: 'Экраны и трансляции', component: Venue, field: ['screens', 'streams'] },
  { key: 'materials', label: 'Материалы', component: Materials, field: 'material_sets' },
];
